export enum KeyTypeEnum {
  DAY = 'DAY',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
  ACROSS_YEAR = 'ACROSS_YEAR',
}
